"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EAgreementActionTypes = void 0;
let EAgreementActionTypes = exports.EAgreementActionTypes = /*#__PURE__*/function (EAgreementActionTypes) {
  EAgreementActionTypes["MarketingSubscriptionAccepted"] = "agreement/marketingSubscriptionAccepted";
  EAgreementActionTypes["LicenceAccepted"] = "agreement/licenceAccepted";
  return EAgreementActionTypes;
}({});